import React from 'react';
import { findDOMNode } from 'react-dom';

export default function(Component) {
	return class Pseudo extends React.Component {
		componentDidMount() {
			this._node.addEventListener('mouseenter', this._onMouseOver);
			this._node.addEventListener('mouseleave', this._onMouseOut);
			this._node.addEventListener('mousedown', this._onMouseDown);
			document.body.addEventListener('mouseup', this._onMouseUp);
		}

		componentWillUnmount() {
			this._node.removeEventListener('mouseenter', this._onMouseOver);
			this._node.removeEventListener('mouseleave', this._onMouseOut);
			this._node.removeEventListener('mousedown', this._onMouseDown);
			document.body.removeEventListener('mouseup', this._onMouseUp);
		}

		_node: HTMLElement;

		_onMouseOver = () => {
			this.setState({ hover: true });
		};

		_onMouseOut = () => {
			this.setState({ hover: false });
		};

		_onMouseDown = () => {
			this.setState({ active: true });
		};

		_onMouseUp = () => {
			this.setState({ active: false });
		};

		render() {
			return (
				<Component
					{...this.props}
					{...this.state}
					ref={r => (this._node = findDOMNode(r) as HTMLElement)}
				/>
			);
		}
	};
}
